import { FC, PropsWithChildren } from 'react';
import AppDropdownMenu from '~/components/dropdown-menu';
import Link from '~/data/strapi/types/shared-components/link';

import HeaderLink from './link';
import styles from './styles.module.css';

interface Props {
  link: Link;
}

const DropdownLink: FC<PropsWithChildren<Props>> = ({ children, link }) => {
  return (
    <AppDropdownMenu
      renderHeadComponent={(isActive) => <HeaderLink data={link} isActive={isActive} />}
      className={styles.dropdown}
      listClassName={styles.dropdownList}
    >
      {children}
    </AppDropdownMenu>
  );
};
export default DropdownLink;
